import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosPaymentInstance, AxiosPropertyInstance } from "../../../common/utils/AxiosInstance";

export const getLegalIndividualReferences = createAsyncThunk(
   'getLegalIndividualReferences',
   async (data, { rejectWithValue }) => {
      const path = `/static/legal/services/individuals/index.json`
      try {
         const res = await AxiosPropertyInstance.get(path)
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getLegalServicePage = createAsyncThunk(
   'getLegalServicePage',
   async (data, { rejectWithValue }) => {
      const path = `/static/legal/services/${data?.serviceType}/${data?.serviceId}/index.json`
      try {
         const res = await AxiosPropertyInstance.get(path)
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getLegalFillDetailsData = createAsyncThunk(
   'getLegalFillDetailsData',
   async (data, { rejectWithValue }) => {
      const path = `/static/legal/services/${data?.serviceType}/${data?.serviceId}/form/index.json`
      try {
         const res = await AxiosPropertyInstance.get(path)
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const legalDocUpload = createAsyncThunk(
   'legalDocUpload',
   async (data, { rejectWithValue }) => {
      const path = `/form/file`
      const token = JSON.parse(localStorage.getItem("token"))
      try {
         const res = await AxiosPropertyInstance.post(path, data, {
            headers: {
               "x-auth-token": token
            }
         })
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const legalDocDelete = createAsyncThunk(
   'legalDocDelete',
   async ({ id, data }, { rejectWithValue }) => {
      const path = `/form/file`
      const token = JSON.parse(localStorage.getItem("token"))
      try {
         const res = await AxiosPropertyInstance.delete(path, {
            headers: {
               "x-auth-token": token
            },
            data
         });
         return { id: id, response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const submitFillDetails = createAsyncThunk(
   'submitFillDetails',
   async (data, { rejectWithValue }) => {
      const path = `/v1/customer/checkout/type/LEGAL_SERVICE`
      const token = JSON.parse(localStorage.getItem("token"))
      try {
         const res = await AxiosPaymentInstance.post(path, data, {
            headers: {
               "x-auth-token": token
            }
         });
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const submitLegalReview = createAsyncThunk(
   'submitLegalReview',
   async (data, { rejectWithValue }) => {
      const path = `/ratings`
      const token = JSON.parse(localStorage.getItem("token"))
      try {
         const res = await AxiosPropertyInstance.post(path, data, {
            headers: {
               "x-auth-token": token
            }
         });
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getLegalReviews = createAsyncThunk(
   'getLegalReviews',
   async (data, { rejectWithValue }) => {
      const path = `/ratings/public/LEGAL_SERVICE/${data?.serviceType}/${data?.documentType}/ratings`
      try {
         const res = await AxiosPropertyInstance.get(path);
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getCustomerReviews = createAsyncThunk(
   'getCustomerReviews',
   async (data, { rejectWithValue }) => {
      const path = `/ratings/public/LEGAL_SERVICE/${data?.serviceType}/${data?.documentType}/reviews?pageSize=${data?.pageSize}&pageIndex=${data?.pageIndex}`
      try {
         const res = await AxiosPropertyInstance.post(path, data);
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getAllLegalReviews = createAsyncThunk(
   'getAllLegalReviews',
   async (data, { rejectWithValue }) => {
      const path = `/ratings/public/LEGAL_SERVICE/peoplesRatings`
      try {
         const res = await AxiosPropertyInstance.get(path);
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

